import { ChangeDetectionStrategy, Component, Inject, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TherapistModel } from '../../../models/api/TherapistModel';
import { Router, RouterModule } from '@angular/router';
import { TherapistService } from '../../../services/api/TherapistService';
import { MatTableModule } from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSort } from '@angular/material/sort';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TherapistAddEditComponent } from '../therapist-add-edit/therapist-add-edit.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar';
import { SystemUserService } from '../../../services/api/SystemUserService';
import { AuthService } from '../../../services/auth/auth.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TherapistDashboardService } from '../../../services/api/TherapistDashboardService';
import { HelpersModule } from '../../../helpers/helpers';

@Component({
  selector: 'app-therapist-list',
  standalone: true,
  imports: [MatTableModule, RouterModule, MatIconModule, MatTooltipModule, MatSortModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatSelectModule, MatSidenavModule, TherapistAddEditComponent, MatDialogContent, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
  templateUrl: './therapist-list.component.html',
  styleUrl: './therapist-list.component.scss'
})
export class TherapistAdminListComponent implements OnInit {
  therapists: TherapistModel[] = [];
  therapistsTemp: TherapistModel[] = [];
  isSidenavOpen = false;
  activeTherapistId: number | null = null;
  readonly dialog = inject(MatDialog);
  isAdmin: boolean = false;

  constructor(
    private router: Router,
    private therapistService: TherapistService,
    private therapistDashboardService: TherapistDashboardService,
    private snackbar: MatSnackBar,
    private systemUserService: SystemUserService,
    private authService: AuthService) {
    const navigation = this.router.getCurrentNavigation();
  }

  displayedColumns: string[] = ['image', 'firstName', 'lastName', 'email', '_therapistStatusID', 'startTime', 'endTime', 'actions'];
  dataSource = new MatTableDataSource<TherapistModel>();

  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit(): void {
    const user = this.authService.getAuthUserRecordFromLocalStorage();

    if (user && user.user.userTypeID === 1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = true;
    }
    this.getTherapists();
  }

  getTherapists() {
    this.therapistService.findTherapist(0, 0).subscribe(data => {

      const therapistData = data.data as unknown as TherapistModel[];

      this.therapists = therapistData;
      this.therapistsTemp = this.therapists;
      this.dataSource.data = this.therapistsTemp;
      this.dataSource.sort = this.sort;

    })
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  filterTable(value: number) {
    this.therapistsTemp = this.therapists;

    if (value > 0) {
      this.therapistsTemp = this.therapistsTemp.filter(t => t.therapistStatusID === value);

    }

    this.dataSource.data = this.therapistsTemp;

  }

  deleteTherapist(therapistId: number | null = null, therapistFirstName: string | null, therapistLastName: string | null, systemUserId: number | null) {

    const deleteDialog = this.dialog.open(TherapistDeleteDialog, {
      data: {
        therapistFirstName: therapistFirstName,
        therapistLastName: therapistLastName,
        therapistId: therapistId,
        systemUserId: systemUserId
      },
      panelClass: 'delete-dialog',
    });

    deleteDialog.afterClosed().subscribe(result => {
      if (result) {
        if (therapistId && systemUserId) {

          this.systemUserService.deleteSystemUser(systemUserId).subscribe({
            next: (response) => {
              this.therapistService.deleteTherapist(therapistId).subscribe({
                next: (response) => {
                  this.getTherapists();
                  this.snackbar.open("THERAPIST DELETED", "CLOSE", {
                    panelClass: "confirm-snackbar",
                  });
                },
                error: (err) => {
                  console.error('Error deleting therapist:', err);
                }
              })
            },
            error: (err) => {
              console.error('Error deleting therapist:', err);
            }
          })
        }
      } else {
      }
    })

  }

  openSidenav(therapistId: number | null = null) {
    this.activeTherapistId = therapistId;
    this.isSidenavOpen = true;
  }

  onSidenavClosed() {
    this.activeTherapistId = 0;
    this.getTherapists();
  }

  getThumbURL(url: string | undefined | null): string | undefined | null {
    if (url == undefined || url == null)
      return url;

    return HelpersModule.cloudinaryURLForceWidth(url, 80);
  }

  clockOut(therapistID: number) {
    if (therapistID && therapistID > 0) {
      this.therapistService.clockOut(therapistID).subscribe({
        next: (data) => {
          this.getTherapists();
          this.snackbar.open("Therapist clocked out", "CLOSE", {
            panelClass: "confirm-snackbar",
          });
        },
        error: (err) => {
        }
      })
    }

  }


  therapistStatusTypeLookup: { [key: number]: string } = {
    1: 'Offline',
    2: 'Clocked In',
    3: 'Available',
    4: 'On Break'
  };

}


@Component({
  selector: 'therapist-delete-dialog',
  templateUrl: 'therapist-delete-dialog.html',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TherapistDeleteDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { therapistId: number, therapistFirstName: string, therapistLastName: string }) { }

  readonly dialogRef = inject(MatDialogRef<TherapistDeleteDialog>);
}
